// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/i18n.ts"
);
import.meta.hot.lastModified = "1748278801902.7173";
}
// REMIX HMR END

export default {
  supportedLngs: ['cs', 'en'],
  fallbackLng: 'cs',
  react: { useSuspense: false },
  backend: {
    loadPath: '../public/locales/{{lng}}.json',
    requestOptions: {
      cache: 'no-store', // Prevent caching
    },
    debug: true,
  },
};
